<template>
	<div v-if="showRevertDraftButton">
		<AppVMenu
			left
			bottom
			rounded="lg"
			v-bind="$attrs"
			min-width="300"
			max-width="300"
			v-on="$listeners"
			:nudge-bottom="34"
			v-model="showMenu"
			:close-on-content-click="false"
			transition="slide-y-transition"
			content-class="publish-errors-dropdown-menu"
		>
			<template v-slot:activator="activator">
				<div @click="onActivatorClick">
					<AnemicButton :disabled="!hasEditPermissions" v-bind:activator="activator" tile class="activator-container px-1">
						{{ versionPublishStatus }}
					</AnemicButton>
				</div>
			</template>
			<div :style="{ marginLeft: `${arrowLeft}px` }" class="arrow-container"><SIcon name="publish-dropdown-arrow" /></div>
			<WorkflowVersionHistoryMenuContent
				@close="closeMenu"
				:workflow="workflow"
				:workflowCurrentDraft="workflowCurrentDraft"
				:workflowCurrentVersion="workflowCurrentVersion"
			/>
		</AppVMenu>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { showRevertDraftButton } from '@/store/modules/featureFlags/getters';
import WorkflowVersionService from '@/components/WorkflowVersionHistory/workflow-version-service';
import WorkflowVersionHistoryMenuContent from '@/components/WorkflowVersionHistory/WorkflowVersionHistoryMenuContent.vue';
export default {
	name: 'WorkflowVersionHistoryMenu',
	components: {
		WorkflowVersionHistoryMenuContent,
	},
	props: {
		hasEditPermissions: { type: Boolean },
		workflow: { type: Object, required: true },
		arrowLeft: { type: [Number, String], default: 250 },
	},
	computed: {
		...mapGetters([showRevertDraftButton.fullPath]),
		showRevertDraftButton() {
			return this[showRevertDraftButton.fullPath];
		},
		versionPublishStatus() {
			return `Version ${this.doesWorkflowNeedPublish ? this.draftVersionNumber : this.currentVersionNumber} - ${
				this.doesWorkflowNeedPublish ? 'draft' : 'published'
			}`;
		},
		draftVersionNumber() {
			return WorkflowVersionService.getWorkflowDraftVersionNumber(this.workflow);
		},
		workflowCurrentVersion() {
			return this.workflow.versions.find((version) => version.id === this.workflowCurrentVersionId);
		},
		workflowCurrentVersionId() {
			return this.workflow.current_version;
		},
		currentVersionNumber() {
			return this.workflowCurrentVersion?.version;
		},
		workflowCurrentDraft() {
			return this.workflow.current_draft;
		},
		doesWorkflowNeedPublish() {
			return this.workflow.draft_pending_changes_flag;
		},
	},
	methods: {
		openMenu() {
			this.showMenu = true;
		},
		closeMenu() {
			this.showMenu = false;
		},
		onActivatorClick(e) {
			if (this.hasEditPermissions) {
				this.openMenu();
				e.stopPropagation();
			}
		},
		startPublish() {
			this.closeMenu();
		},
	},
	data() {
		return { showMenu: false };
	},
};
</script>

<style scoped lang="scss">
.activator-container {
	height: 22px !important;
	cursor: pointer !important;
	border-radius: 6px !important;
	background: #f5f7fa !important;
	border: 1px solid #d6ddea !important;

	color: black !important;
	font-size: 11px !important;
	font-weight: 300 !important;
	line-height: 13px !important;
	letter-spacing: 0px !important;
	text-transform: none !important;
}

.arrow-container {
	margin-top: -10px;
	position: fixed !important;
}
</style>
